// extracted by mini-css-extract-plugin
export default {"spanName":"EditableNameInput_spanName__936lJ","inputName":"EditableNameInput_inputName__w5s9h"};